import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import { store } from "@/store";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBjrWMEiu6d7jyyflNteSPK8P1rDhCawyA",
  authDomain: "bujinkan-hamburg.firebaseapp.com",
  projectId: "bujinkan-hamburg",
  storageBucket: "bujinkan-hamburg.appspot.com",
  messagingSenderId: "246545776344",
  appId: "1:246545776344:web:5350ec2390f772fee421ad",
  measurementId: "G-6RJKHPVH07",
};
// Initialize Firebase
initializeApp(firebaseConfig);

const app = createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(router)
  .use(store);
app.mount("#app");
